import script from "./PCPartsItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsItemCard.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsItemCard.vue?vue&type=style&index=0&id=c0440088&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0440088"]])

export default __exports__